import React from 'react'
import { connect } from 'react-redux'
import SalaryDepRatioDiv from './SalaryDepRatioDiv'
import {
	addListItem, changeListItem, deleteListItem, getListFromValues, addListItemsFromListItems,
	hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'

class SalaryRatioDiv extends React.Component {
	state = {
		bReadOnly: this.props.bReadOnly || false,
		id: this.props.id || 0,
		personID: this.props.personID || 0,
	}

	componentDidMount = () => {
		this.doGetSalaryRatio()
	}

	doGetSalaryRatio = () => {
		const { id, personID, bReadOnly } = this.state
		Tyan.doPostEvent('GetSalaryRatio', {
			data: { id, personID },
			onEnd: ({ errorMessage, optionsParas, readOnly, initValues基本信息 }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					this.setState({ id, bReadOnly: bReadOnly || readOnly, optionsParas, initValues基本信息, changedValues基本信息: {} })
				}
			}
		})
	}

	handlerSave = () => {
		const { onClose, onRefresh, } = this.props
		const { id, personID, changedValues基本信息 } = this.state
		Tyan.doPostEvent('SaveSalaryRatio', {
			data: { id, personID, changedValues基本信息 },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				} else {
					Ext.toast('保存成功')
					onRefresh && onRefresh()
					onClose && onClose()
				}
			}
		})
	}

	handlerDelete = () => {
		const { onClose, onRefresh } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent('DelSalaryRatio', {
				data: { id, },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
					}
					else {
						Ext.toast('删除成功')
						onRefresh && onRefresh()
						onClose && onClose()
					}
				}
			})
		)
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	canSave = () => {
		return this.bChanged() && getFormValue(this, '基本信息', '生效月份')
	}

	bChanged = () => {
		return hasChangedValues(this)
	}

	fieldset基本信息 = () => {
		const { bReadOnly, optionsParas } = this.state
		return [
			{ _select: '生效月份', minWidth: '95%', required: true, disabled: bReadOnly, },
			{
				_grid: '', name: '薪资部门比例', rowNumbers: true, minWidth: '100%',
				columns: [
					{ _text: '薪资承担部门', minWidth: 150, flex: 2, },
					{ _text: '部门承担比例(%)', name: '部门承担比例', minWidth: 150, flex: 1, },
					{ _text: '人数统计', minWidth: 150, flex: 1, },
				],
				buttons: [
					{
						_button: '添加...', cdt: () => !bReadOnly, handler: () =>
							Tyan.pubForm.showDialog('薪资部门比例', props => <SalaryDepRatioDiv {...props} initValues基本信息={''} optionsParas={optionsParas} bReadOnly={bReadOnly}
								onSave={(changedValues) => addListItem(this, { ...changedValues }, '基本信息', '薪资部门比例')}
							/>)
					}
				],
				onDoubleTap: data => {
					Tyan.pubForm.showDialog('薪资部门比例', props => <SalaryDepRatioDiv {...props} initValues基本信息={data} optionsParas={optionsParas} bReadOnly={bReadOnly}
						onSave={(changedValues) => changeListItem(this, changedValues, {}, '基本信息', '薪资部门比例', data.id)}
						onDelete={() => deleteListItem(this, '基本信息', '薪资部门比例', data.id)}
					/>)
				},
			},
			{ _text: '备注', minWidth: '95%', maxRows: 3 },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, } = this.props
		const { errorMessage, id, initValues基本信息, bReadOnly } = this.state

		if (errorMessage) return Tyan.pubForm.showError(errorMessage)
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />

		return <Body data={this} maxWidth="1000"
			controls={
				bReadOnly && [{ _button: '关闭', icon: 'close', handler: this.handlerClose }] ||
				[
					{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.canSave() },
					{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0 },
					{ _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
				]
			}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
				]}
		/>
	}
}

export default connect()(SalaryRatioDiv)